export const headCells = [
  //for zero(0) index for Trust/Customers
  [
    {
      id: 'id',
      label: 'Id',
      sortable: false,
      align: 'left',
      numIndex: 0,
      width: "5%",
      activeIndexOnly: true,
    },
    {
      id: 'timesheet_name',
      label: 'Timesheet Name',
      sortable: true,
      align: 'left',
      numIndex: 0,
      // width: "70%",
      activeIndexOnly: true,
    }, {
      id: 'timesheet_name',
      label: 'Created By',
      sortable: true,
      align: 'left',
      numIndex: 0,
      // width: "70%",
      activeIndexOnly: true,
    }, {
      id: 'timesheet_name',
      label: 'Created Date',
      sortable: true,
      align: 'left',
      numIndex: 0,
      // width: "70%",
      activeIndexOnly: true,
    },
    // {
    //   id: 'Invoice',
    //   label: '',
    //   sortable: false,
    //   align: 'right',
    //   numIndex: 0,
    //   activeIndexOnly: true,
    // },
    // {
    //   id: 'Invoice',
    //   label: '',
    //   sortable: false,
    //   align: 'right',
    //   numIndex: 0,
    //   activeIndexOnly: true,
    // },
    {
      id: 'action',
      label: 'Action',
      sortable: false,
      align: 'center',
      numIndex: 0,
      width: "20%",
      activeIndexOnly: true,
    },
  ],


]
